import { render, staticRenderFns } from "./PositionView.vue?vue&type=template&id=4a671fb5&"
import script from "./PositionView.vue?vue&type=script&lang=js&"
export * from "./PositionView.vue?vue&type=script&lang=js&"
import style0 from "./PositionView.vue?vue&type=style&index=0&id=4a671fb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports